import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-green-400 to-green-300 bg-clip-text text-transparent">Assets Dairy Farm</h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              India's most trusted dairy investment platform. Invest in our farm and get guaranteed 60% returns per annum.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition"><FaFacebookF size={14} /></a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition"><FaInstagram size={14} /></a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition"><FaTwitter size={14} /></a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition"><FaYoutube size={14} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Quick Links</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/" className="hover:text-green-400 transition">Home</Link></li>
              <li><Link to="/about" className="hover:text-green-400 transition">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-green-400 transition">Contact</Link></li>
              <li><Link to="/investor/plans" className="hover:text-green-400 transition">Investment Plans</Link></li>
            </ul>
          </div>

          {/* Legal - FIXED LINKS */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Legal</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/privacy-policy" className="hover:text-green-400 transition">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-green-400 transition">Terms & Conditions</Link></li>
              <li><Link to="/refund-policy" className="hover:text-green-400 transition">Refund Policy</Link></li>
              <li><Link to="/faq" className="hover:text-green-400 transition">FAQs</Link></li>
            </ul>
          </div>

          {/* Contact - UPDATED WITH YOUR DETAILS */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Contact Us</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1 text-green-400" />
                <span>Village & Post Addra, District Barabanki, Uttar Pradesh - 225207</span>
              </li>
              <li className="flex items-center gap-3">
                <FaPhoneAlt className="text-green-400" />
                <span>+91 84230 45733</span>
              </li>
              <li className="flex items-center gap-3">
                <FaEnvelope className="text-green-400" />
                <span>Assetsdairyfarm@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {currentYear} Assets Dairy Farm. All rights reserved. | Designed with ❤️ for investors</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;